import PropTypes from "prop-types"
import { useState } from "react"
import { connect } from "react-redux"

import { updateChoice } from "areas/product/store/actions"
import { closeModal } from "components/modal"
import Button from "components/ui/button"
import Image from "components/ui/image"
import { imageLookup } from "helpers/product/image-lookup"
import { storePref } from "helpers/user-prefs"
import { cn } from "styles/utils"

const InternalBoxDesign = ({ boxDimensions, boxDesigns, selectDesign }) => {
  const [selectedCategory, setCategory] = useState(0)

  return (
    <>
      <h3 className="body-lg">Select a category</h3>
      <div
        className="border-b-grey-65 tablet:overflow-x-auto overflow-x-scroll whitespace-nowrap border-b pl-8 pr-16"
        data-cy="product-box-design-category"
      >
        {boxDesigns.map((category, index) => (
          <Button
            className={cn(
              "inline-block p-12",
              selectedCategory === index ? "text-selected" : "text-neutral"
            )}
            data-cy={`product-box-design-category-${category.name}`}
            key={`box_category_${category.id}`}
            onClick={() => setCategory(index)}
            text
          >
            {category.name}
          </Button>
        ))}
      </div>
      <h3 className="body-lg mt-16">Choose a design</h3>
      <div
        className="tablet:grid-cols-3 grid grid-cols-2 gap-8 overflow-auto px-8"
        data-cy="product-box-design-image"
      >
        {boxDesigns[selectedCategory].designs.map((design) => (
          <Button
            className="mb-16"
            key={`box_design_${design.id}`}
            onClick={() => selectDesign(design)}
            variant="text"
          >
            <Image
              alt={design.name}
              className="w-full cursor-pointer bg-black"
              height="1024"
              src={imageLookup(
                "design",
                `${boxDimensions.design_file_prefix}${design.name}_${boxDimensions.box_width}_${boxDimensions.box_height}`,
                "simple"
              )}
              width="1024"
            />
          </Button>
        ))}
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    boxDesignOption: state.wizard.data?.box?.options?.find(
      (opt) => opt.selected_type == "design"
    ),
    boxDesigns: state.boxDesigns,
    boxDimensions: state.wizard.data?.box?.design,
  }
}

const mapDispatchToProps = (dispatch) => {
  return { dispatch }
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { boxDesignOption, boxDimensions } = stateProps
  const { dispatch } = dispatchProps

  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    selectDesign: (design) => {
      let opt = boxDesignOption
      opt.value =
        opt.design_value = `${boxDimensions.design_file_prefix}${design.name}_${boxDimensions.print_box_width}_${boxDimensions.print_box_height}`
      dispatch(updateChoice("box", opt, true))
      storePref(
        "design_box",
        `${boxDimensions.design_file_prefix}${design.name}`
      )
      closeModal()
    },
  }
}

InternalBoxDesign.propTypes = {
  boxDesignOption: PropTypes.object,
  boxDesigns: PropTypes.array,
  boxDimensions: PropTypes.object,
  selectDesign: PropTypes.func,
}

const BoxDesign = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(InternalBoxDesign)

export default BoxDesign
